import { useEffect } from "react";

/**
 * Lightweight per-page SEO updater (no react-helmet dependency).
 * Updates <title>, meta description, canonical link, and OG tags on route change.
 *
 * Usage:
 *   <SEO title="About — KhojByte" description="..." path="/about" />
 */
const SITE = "https://khojbyte.com";
const DEFAULT_DESC =
  "KhojByte Research Lab — Nepal's not-for-profit research publication consultation. Research services in Nepal, research help in Nepal, paper help in Nepal: idea-to-publication workflow, AI-assisted mentor matching, journal & conference database, LMS courses, and researcher portfolios.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({ title, description, path = "", image, noindex = false, keywords }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · KhojByte Research Lab` : "KhojByte Research Lab — Research Services, Paper Help & Thesis Guidance in Nepal";
    const desc = description || DEFAULT_DESC;
    const url = `${SITE}${path || (typeof window !== "undefined" ? window.location.pathname : "/")}`;
    document.title = fullTitle;
    setMeta("description", desc);
    if (keywords) setMeta("keywords", keywords);
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:url", url, "property");
    setMeta("og:type", "website", "property");
    if (image) setMeta("og:image", image, "property");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);
    setMeta("twitter:card", "summary_large_image");
    // Robots — flip to noindex on 404-ish states so Google doesn't keep
    // soft-404 impressions for routes that no longer resolve.
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);
  }, [title, description, path, image, noindex, keywords]);
  return null;
}
